import axios from 'axios';
import { call, all, put, takeLatest, select, delay } from 'redux-saga/effects';

import { AppStateType } from '../root-reducer';

import { ProductStateListInterface } from './product-list-interface';

import { ISA_ERROR } from '~/constants';
import { GET_LIST_PRODUCT_REQUEST } from './product-list-constants';

import * as productActions from './product-list-actions';

import productService from './product-list-service';

let cancel: any;
const CancelToken = axios.CancelToken;

export function* getListProduct({
  type,
  payload
}: {
  type: any;
  payload: {
    queryString?: string;
    subsidiaryExternalCode?: string;
    brand?: string;
    onlyWithStock?: boolean;
    onlyExternalCode?: boolean;
  };
}) {
  if (payload?.queryString) {
    yield delay(1000);
  } else {
    yield delay(200);
  }

  if (cancel !== undefined) cancel();
  const cancelToken = new CancelToken(function executor(c) {
    cancel = c;
  });

  try {
    yield put(productActions.setLoadingData(true));
    const { rowsPerPage, page, order, orderBy }: ProductStateListInterface = yield select(
      (state: AppStateType) => state.productList.list
    );

    const pagination = {
      skip: page === 0 ? 0 : page * rowsPerPage,
      limit: rowsPerPage,
      orderAsc: order === 'asc' ? false : true,
      orderBy
    };

    const filters = {
      ...payload,
      externalCode: payload?.onlyExternalCode ? payload.queryString : undefined,
      fieldsToShow: 'externalCode,name,pictures,paymentPlansGroup,brand,stocks,prices,tributacao',
      subsidiaryExternalCode: payload?.subsidiaryExternalCode ?? ''
    };

    const { data: productsList } = yield call(
      productService.getListProducts,
      {
        ...pagination,
        ...filters
      },
      {
        cancelToken
      }
    );

    const { data: countList } = yield call(
      productService.getListProductsCount,
      {
        ...filters
      },
      {
        cancelToken
      }
    );

    const parsedProducts = productsList?.products?.map(product => ({
      ...product,
      baseValue: product?.price?.price
    }));

    yield put(
      productActions.getListProductsSuccess({
        products: parsedProducts,
        rowsCount: countList?.products[0]?.count,
        decimals: productsList?.decimals
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(productActions.setLoadingData(false));
  }
}

export default all([takeLatest(GET_LIST_PRODUCT_REQUEST, getListProduct)]);
